import React, { useEffect } from "react";
import { useState } from "react";
import { FaXmark } from "react-icons/fa6";
import SelectBox from "../reduxworkbook/components/Aside2Components/DropzoneComponents/FilterConfigCompComponents/SelectBox";
import {
  useGetJoiningTablesMutation,
  useGetSchemasMutation,
} from "./JoinTableApiSlice";

export default function TablesModal({
  closeModal,
  addType,
  sourceId,
  baseDatabaseName,
  joinObject,
  setJoinObject,
  openRelationshipModal,
  databaseId,
}) {
  // // console.log(baseDatabaseName);
  // console.log(addType);
  // console.log(sourceId);

  const [allTables, setAllTables] = useState([]);
  const [schemasArray, setSchemasArray] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTable, setSelectedTable] = useState(null);
  // Fetch the tables
  const [
    getTables,
    {
      data: tablesData,
      isError: isTablesError,
      isLoading: isTablesLoading,
      isSuccess: isTablesSuccess,
      error: tableError,
    },
  ] = useGetJoiningTablesMutation();
  // Fetch schemas
  // const [
  //   getSchemas,
  //   {
  //     data: schemas,
  //     isError: isSchemaError,
  //     isLoading: isSchemaLoading,
  //     isSuccess: isSchemaSuccess,
  //     error: schemaError,
  //   },
  // ] = useGetSchemasMutation();
  // useEffect(() => {
  //   getSchemas();
  // }, []);
  useEffect(() => {
    if (baseDatabaseName) {
      const object = { dataSourceId: databaseId };
      getTables(object);
    }
  }, []);
  // useEffect(() => {
  //   if (schemas && schemas["response"] && schemas["response"]["databases"]) {
  //     function modifiedArray(array) {
  //       const modifiedArray = array.map((db) => {
  //         return {
  //           label: db,
  //           value: db,
  //         };
  //       });
  //       return modifiedArray;
  //     }
  //     const modifiedDatabasesArray = modifiedArray(
  //       schemas["response"]["databases"]
  //     );
  //     setSchemasArray(modifiedDatabasesArray);
  //   }
  // }, [isSchemaSuccess]);
  useEffect(() => {
    if (
      tablesData &&
      tablesData["response"] &&
      tablesData["response"]["tables"]
    ) {
      setAllTables(tablesData["response"]["tables"]);
    }
  }, [isTablesSuccess]);
  const handleSchema = (e) => {
    const selected = schemasArray.find((item) => item.value === e.target.value);
    if (selected) {
      setJoinObject((prev) => ({ ...prev, newTableDatabase: selected.value }));
    }
  };
  const filteredOptions = allTables.filter((option) => {
    return option.toLowerCase().includes(searchTerm.toLowerCase());
  });
  // console.log(filteredOptions);
  const handleSearchTable = (e) => {
    setSearchTerm(e.target.value);
  };
  // console.log(tableError);

  const handleOkay = () => {
    // // console.log(selectedTable);
    // // console.log(addType);
    // // console.log(sourceId);
    // setTempItemObject({ selectedTable, addType, sourceId });
    closeModal();
    openRelationshipModal();
  };

  return (
    <main className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <section
        className={`flex flex-col bg-white shadow-2xl rounded w-full max-w-lg justify-between items-center gap-0`}
      >
        <header className="flex bg-gray-50 w-full p-2 items-center justify-between rounded-t-lg  font-medium">
          Select Tables for {addType === "columns" ? "Join" : "Merge"}
          <button onClick={closeModal}>
            <FaXmark />
          </button>
        </header>
        {/* <div className="flex flex-col gap-2 justify-center items-start w-full p-2">
          <span className="font-medium">Databases :</span>
          <SelectBox
            value={joinObject?.newTableDatabase}
            optionsArray={schemasArray}
            onChange={handleSchema}
            isArrayBig={schemasArray.length > 6}
          />
        </div> */}
        <div className="flex flex-col gap-2 justify-start items-start w-full p-2">
          <span className="font-medium">Tables :</span>
          <input
            autoComplete="off"
            type="search"
            name="query"
            placeholder="search tables..."
            onChange={handleSearchTable}
            className="px-3 w-full rounded py-[3px] border outline-none"
          />
          <div className="flex flex-col justify-start items-start w-full h-60 overflow-y-auto">
            {isTablesError ? (
              <div className="text-left font-medium text-red-500">
                {tableError
                  ? tableError?.data?.message
                  : "An error occured while loading the tables..."}
              </div>
            ) : null}
            {isTablesSuccess
              ? filteredOptions.map((item, index) => (
                  <button
                    onClick={() => {
                      setJoinObject((prev) => ({
                        ...prev,
                        newTableName: item,
                      }));
                      setSelectedTable(item);
                    }}
                    className={`w-full flex items-center justify-start p-1 border-b rounded ${
                      joinObject?.newTableName === item
                        ? "bg-blue-950 text-white"
                        : "hover:bg-gray-100"
                    }`}
                    key={index}
                  >
                    {item}
                  </button>
                ))
              : null}
          </div>
        </div>
        <footer className="flex justify-between items-center w-full p-2 bg-gray-50">
          <div className="text-sm text-left w-full">
            {isTablesLoading ? (
              <p className=" text-yellow-500 font-medium">loading tables...</p>
            ) : null}
          </div>
          <button
            className="border py-1 px-2 tracking-wide mr-2 text-gray-700 hover:bg-gray-200"
            onClick={closeModal}
          >
            Close
          </button>
          <button
            className={`border py-1 px-2 tracking-wide ${
              joinObject?.newTableName === null
                ? "bg-gray-400 text-black"
                : "bg-blue-950 text-white"
            }`}
            disabled={!joinObject?.newTableName}
            onClick={handleOkay}
          >
            Okay
          </button>
        </footer>
      </section>
    </main>
  );
}
